import { Grid, Typography } from "@mui/material";
import * as React from "react";
import {
  getDropDown,
  getInputBox,
} from "../../../../sharedComponents/formFields/LabelInFormFields";
import { useStyles } from "./UpdatePlayerDetails";

const BasicAnthroComponent = ({
  formData,
  handleInputChange,
  dropDownData,
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Typography
          noWrap
          variant="subtitle1"
          className={classes.firstSectionTitle}
        >
          Basic Anthro
        </Typography>
      </Grid>
      <Grid
        container
        spacing={1}
        sx={{ paddingTop: "27px", justifyContent: "space-between" }}
      >
        <Grid item lg={6} md={6} xs={6} sm={6}>
          {getInputBox(
            "Height (ft')",
            formData.heightInFeet,
            (e) => {
              handleInputChange(e, "heightInFeet");
            },
            false,
            "number"
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          {getInputBox(
            `Height (in")`,
            formData.heightInInches,
            (e) => {
              handleInputChange(e, "heightInInches");
            },
            false,
            "number"
          )}
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          {getInputBox(
            `Weight`,
            formData.weight,
            (e) => {
              handleInputChange(e, "weight");
            },
            false,
            "number"
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          {getDropDown(
            "Position",
            formData.positionId,
            (e) => {
              handleInputChange(e, "positionId");
            },
            dropDownData.position
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default React.memo(BasicAnthroComponent);
